import React from "react";
import { Landing } from "./Landing";
export class Home extends React.Component {
  render() {
    return (
      <>
      <Landing/>
      </>
    );
  }
}
